import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import {Box, CircularProgress, Paper} from '@mui/material'
import Stack from '@mui/material/Stack'
import GroupsIcon from '@mui/icons-material/Groups'
import HowToRegIcon from '@mui/icons-material/HowToReg'
import {classesIP} from '../selectedPersonaStyles'
import {classes} from '../../PersonaSummary/SummaryComponentStyles'
import {SuperscriptDagger} from '../../../common/Dagger'
import ZeroPopulationBanner from '../../ZeroPopulationBanner'

const OverviewKeyChar1 = ({
  adultCount,
  population,
  loadingPersonaOverview,
  isZeroCountPopulation,
  handlePersonaCustomLabel
}) => {
  return (
    <>
      {loadingPersonaOverview && <CircularProgress className={classesIP.CircularProgress} size={15} title="loading" />}

      <Typography
        sx={{mt: -1}}
        className={classesIP.personaSubTitle}
        tabIndex={0}
        aria-label={'Key Characteristics Section'}
      >
        {handlePersonaCustomLabel('overview', 'KEY CHARACTERISTICS')}
      </Typography>

      {isZeroCountPopulation && <ZeroPopulationBanner />}

      <Box className={classesIP.overviewBox}>
        <Paper elevation={1} className={classes.summaryPadding}>
          <Stack spacing={{xs: 1, sm: 1}} direction="row" useFlexGap className={classes.summaryCommMainStack}>
            <Stack
              className={[classesIP.overviewKeyChar1Stack, classesIP.wide]}
              tabIndex={0}
              aria-label={`${adultCount}, Selected Adults`}
            >
              <Stack direction="row" className={classesIP.overviewKeyChar1Stack} spacing={1}>
                <HowToRegIcon className={classesIP.overviewKeyChar1Icon} />
                <Typography className={classesIP.personaSubTitle2}>
                  {adultCount}
                  {isZeroCountPopulation && <SuperscriptDagger width={10} height={10} />}
                </Typography>
              </Stack>
              <Typography className={classesIP.personaStackText}>
                {handlePersonaCustomLabel('overview', 'Selected Adults')}
              </Typography>
            </Stack>

            <Stack
              className={[classesIP.overviewKeyChar1Stack, classesIP.wide]}
              tabIndex={0}
              aria-label={`${population}, of Selected Adult Population`}
            >
              <Stack direction="row" className={classesIP.overviewKeyChar1Stack} spacing={1}>
                <GroupsIcon className={classesIP.overviewKeyChar1Icon} />
                <Typography className={classesIP.personaSubTitle2}>
                  {population}%{isZeroCountPopulation && <SuperscriptDagger width={10} height={10} />}
                </Typography>
              </Stack>
              <Typography className={classesIP.personaStackText}>
                {handlePersonaCustomLabel('overview', 'of Selected Adult Population')}
              </Typography>
            </Stack>
          </Stack>
        </Paper>
      </Box>
    </>
  )
}
OverviewKeyChar1.propTypes = {
  adultCount: PropTypes.number.isRequired,
  population: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  loadingPersonaOverview: PropTypes.bool.isRequired,
  isZeroCountPopulation: PropTypes.bool.isRequired,
  handlePersonaCustomLabel: PropTypes.func.isRequired
}

export default OverviewKeyChar1
